import requestStatuses from '@clearscore/constants.request-statuses';

import { ROUTES_REINITIALISE } from '../types';

/**
 * Route initial state
 * @returns {array}
 */
const initialState = {
    current: 'global',
    fetchStatus: requestStatuses.SUCCESS,
};

/**
 * Routes Domain Reducer
 * @param state
 * @param action
 */
export default function routesReducer(state = initialState, { type, payload } = {}) {
    switch (type) {
        case ROUTES_REINITIALISE:
            return {
                ...state,
                current: payload.market,
            };
        default:
            return state;
    }
}
